export enum Theme {
  light = 'light',
  dark = 'dark',
}

export const DEFAULT_THEME = Theme.light;
